import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { OOMenuItem } from 'src/app/shared/models/oo-menu-item';

@Component({
	selector: 'app-integration-external-integration-setup',
	templateUrl: './integration-external-integration-setup.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class IntegrationExternalIntegrationSetupComponent implements OnInit, OnDestroy {
	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	itemListSubscription: Subscription;
	menuItemList: OOMenuItem[];

	constructor(public app: AppService, public venueSvc: OOVenueService, private focuslink: FocuslinkService) {}
	ngOnDestroy(): void {
		this.itemListSubscription.unsubscribe();
	}

	ngOnInit(): void {
		this.itemListSubscription = this.venueSvc.subscriptionOOmenuItems.subscribe((items) => {
			this.menuItemList = [...items];
			this.sortItems();
		});
		this.menuItemList = [...this.venueSvc.ooMenuItems];
		this.sortItems();
	}

	sortItems() {
		this.menuItemList.sort((a, b) => (a.name > b.name ? 1 : -1));
	}
}
